import type { AuditItem } from '../../../types/features/storeDetails/legacyAudits';

export const extractLegacyChildRowValues = (item: AuditItem) => {
  const posLottoSales = Number(item?.pos_data?.pos_summary?.lotto_sales) ?? 0;
  const lottoSystemSales = Number(item?.lotto_summary?.sales) ?? 0;
  const lottoPayoutsTotal = Number(item?.lotto_summary?.payouts_total) ?? 0;
  const freeTicketsPaid = Number(item?.lotto_summary?.scratcher_free_tickets_paid_amount) ?? 0;
  const posPayout = Number(item?.pos_data?.pos_summary?.payout) ?? 0;
  const posScratcherQuantity = Number(item?.pos_data?.pos_summary?.scratcher_quantity_sold) ?? 0;
  const totalSold = Number(item?.total_sold) ?? 0;
  const posScratcherSales = Number(item?.pos_data?.pos_summary?.scratcher_sales) ?? 0;
  const revenue = Number(item?.revenue) ?? 0;

  const isPosZero = posScratcherQuantity === 0 && posScratcherSales === 0 && posLottoSales === 0 && posPayout === 0;
  const isLottoZero = lottoSystemSales === 0 && lottoPayoutsTotal === 0 && freeTicketsPaid === 0;

  return {
    posLottoSales,
    posPayout,
    posScratcherQuantity,
    totalSold,
    posScratcherSales,
    revenue,
    isPosZero,
    isLottoZero,
  };
};

